import { render, staticRenderFns } from "./enum-show.vue?vue&type=template&id=52e25d46&scoped=true&"
import script from "./enum-show.vue?vue&type=script&lang=js&"
export * from "./enum-show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e25d46",
  null
  
)

export default component.exports